import { AccessorialCode, Money } from '@rygen/rygen-ui/model';
import { ICostAllocationSourceInvoiceLineItem } from '@rygen/rygen-ui/model/costAllocation';

export class ShipmentRateSourceInvoiceLineItem implements ICostAllocationSourceInvoiceLineItem {
  id?: number;
  invoiceId?: number;
  invoiceEntityType?: 'CARRIER_INVOICE' | 'CLIENT_INVOICE';
  // there are many more invoice types, but the handling for non-original (minus cost-estimate) are all the same
  invoiceType?: 'ORIGINAL' | 'COST_ESTIMATE';
  chargeCode?: AccessorialCode;
  description?: string;
  amount?: Money;
  uid?: string;

  constructor(opts?: Partial<ShipmentRateSourceInvoiceLineItem>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.invoiceId != null) {
      this.invoiceId = opts.invoiceId;
    }
    if (opts?.invoiceEntityType != null) {
      this.invoiceEntityType = opts.invoiceEntityType;
    }
    if (opts?.invoiceType != null) {
      this.invoiceType = opts.invoiceType;
    }
    if (opts?.chargeCode != null) {
      this.chargeCode = new AccessorialCode(opts.chargeCode);
    }
    if (opts?.description != null) {
      this.description = opts.description;
    }
    if (opts?.amount != null) {
      this.amount = new Money(opts.amount);
    }
    if (opts?.uid != null) {
      this.uid = opts.uid;
    }
  }

  copyLineItemInstance(): ICostAllocationSourceInvoiceLineItem {
    return new ShipmentRateSourceInvoiceLineItem(this);
  }

  getAmountForCostAllocation(): Money | undefined {
    return this.amount;
  }
}
